export default __webpack_public_path__ + "static/media/e.819622d1.svg";